// V12.9: tokenização de cartão no Mercado Pago (navegador) p/ fallback automático.
// Carrega o SDK MP.js sob demanda e gera o token + payment_method_id. Falha silenciosa:
// se não der, retorna {} e o checkout segue só com a Asaas.
let _sdkPromise = null;
let _mp = null;

function loadSdk() {
  if (window.MercadoPago) return Promise.resolve();
  if (_sdkPromise) return _sdkPromise;
  _sdkPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://sdk.mercadopago.com/js/v2";
    s.async = true;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return _sdkPromise;
}

async function getMp() {
  const pk = process.env.REACT_APP_MP_PUBLIC_KEY;
  if (!pk) return null;
  await loadSdk();
  if (!_mp && window.MercadoPago) _mp = new window.MercadoPago(pk, { locale: "pt-BR" });
  return _mp;
}

// V13.8: pré-carrega o SDK do MP (seta window.MP_DEVICE_SESSION_ID) assim que o form abre.
export async function preloadMp() {
  try { await getMp(); } catch { /* ignora */ }
}

// V13.8: device session id do MP.js (anti-fraude). O SDK seta window.MP_DEVICE_SESSION_ID ao carregar.
export function getMpDeviceId() {
  try {
    return window.MP_DEVICE_SESSION_ID || "";
  } catch {
    return "";
  }
}

export async function createMpCardToken({ number, holder, mm, yy, ccv, cpf }) {
  try {
    const mp = await getMp();
    if (!mp) return {};
    const resp = await mp.createCardToken({
      cardNumber: number,
      cardholderName: holder,
      cardExpirationMonth: mm,
      cardExpirationYear: String(yy).slice(-4),
      securityCode: ccv,
      identificationType: "CPF",
      identificationNumber: (cpf || "").replace(/\D/g, "") || "00000000000",
    });
    let pmId = "";
    try {
      const methods = await mp.getPaymentMethods({ bin: number.slice(0, 6) });
      pmId = methods?.results?.[0]?.id || "";
    } catch { /* ignora */ }
    return { mp_card_token: resp?.id || "", mp_payment_method_id: pmId, mp_device_id: getMpDeviceId() };
  } catch {
    return { mp_device_id: getMpDeviceId() };
  }
}
